"use strict";

module.exports = {
  backgroundImage: 'https://cah-com-res.cloudinary.com/image/upload/v1523922065/assets/house-background-self-show.jpg'
};
//# sourceMappingURL=assets.js.map